import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=cfdc6048&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=cfdc6048&prod&scoped=true&lang=css&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=cfdc6048&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdc6048",
  null
  
)

export default component.exports